import React from 'react';
import './Message.css';
import {auth} from './firebase';

const Message = ({ message,timestamp,user,userImage }) => {
    const { displayName } = auth.currentUser;
    const messageClass = displayName === user ? 'sent' : 'received'; //conditional css to show sent message on right

    return (
        <div className={`message ${messageClass}`}>
        	<img src={userImage} alt='' />
        	<div className='message__info'>
        		<h4>{user} 
        		<span className='message__timestamp'>
                    {new Date(timestamp?.toDate()).toUTCString()}
                </span>
        		</h4>
        		<p>{message}</p>
        	</div>
        </div>
    );
};

export default Message;
